import { Typography } from '@mui/material';

export default function H4({ children, style }) {
  return (
    <Typography
      variant="h5"
      gutterBottom
      component="div"
      style={{ ...style }}>
      {children}
    </Typography>
  );
}
